<section class="container py-3">
  <!-- Page Header -->
  <div class="page-header-container">
    <div class="page-title-container">
      <button mat-icon-button class="back_icon me-2" (click)="goBack()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <h1 class="page-title" translate>Submission Details</h1>
    </div>
  </div>

  <!-- Submission Header -->
  <div class="submission-header">
    <!-- Submission Header Card -->
    <mat-card class="submission-header-card">
      <mat-card-content>
        <div class="header-top">
          <div class="student-info">
            <span class="student-name"
              >{{ submissionData.header.studentName }}
            </span>
            <span class="student-id"
              >({{ submissionData.header.studentId }})</span
            >
          </div>
          <span
            class="status"
            [ngClass]="{
              'on-time': submissionData.header.onTime,
              late: !submissionData.header.onTime
            }"
          >
            {{ submissionData.header.onTime ? "On Time" : "Late" }}
          </span>
        </div>

        <div class="header-bottom">
          <div class="submitted-date">
            <span translate>Submitted on dt:</span>
            <strong>{{ submissionData.header.submittedOn }}</strong>
          </div>
        </div>
        <mat-divider></mat-divider>

        <div class="p-2">
          <h4 translate>Assignments:</h4>
          <div>
            <p>
              <b>{{ submissionData.header.assignment.title }}</b>
            </p>
            <p>{{ submissionData.header.assignment.subTitle }}</p>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Questions Loop -->
  <div class="questions_container">
    <mat-card
      *ngFor="let q of submissionData.questions; let i = index"
      class="submission-card"
    >
      <mat-card-content>
        <!-- Question -->
        <div class="question-section">
          <h4 class="question-title"><span translate>Question</span> {{ i + 1 }}</h4>
          <p class="question-desc">{{ q.question }}</p>
        </div>

        <!-- Answer -->
        <div class="answer-section">
          <h4 class="answer-title"><span translate>Answer</span> {{ i + 1 }}</h4>
          <pre class="answer-desc">{{ q.answer }}</pre>
        </div>

        <!-- Grade -->
        <div class="grade-section">
          <mat-form-field class="grade-field">
            <mat-label translate>Grade/Marks</mat-label>
            <input
              matInput
              type="number"
              min="0"
              max="10"
              [(ngModel)]="q.grade"
            />
          </mat-form-field>
          <span>/ 10</span>
        </div>

        <!-- Remarks -->
        <div class="remarks-section">
          <mat-form-field class="full-width">
            <mat-label translate>Add Remarks / Comments</mat-label>
            <textarea
              matInput
              type="text"
              placeholder="Ex. It makes me feel..."
              [(ngModel)]="q.remarks"
            ></textarea>
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="action-buttons">
    <button mat-flat-button translate>Save & Exit</button>
    <button mat-flat-button color="primary" translate>Save & Next Student</button>
  </div>
</section>
